import { ReactNode } from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import { Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormInput, FormInputProps } from '../../components/form/FormInput';
import { FormSelectProps } from '../../components/form/FormSelect';

type Props = {
  control: Control<any>;
  slots?: { actionArea?: ReactNode; end?: ReactNode };
  readonly?: boolean;
  inputProps?: Partial<FormInputProps & FormSelectProps>;
};

export const InvoiceManagementCustomerFormPart = ({ inputProps, control, slots, readonly }: Props) => {
  const { t } = useTranslation();

  return (
    <Grid container spacing={2} mt={1} px={0} py={2}>
      <Grid xs={12} md={6}>
        <FormInput
          {...inputProps}
          readonly={readonly}
          control={control}
          name={'customer.vatId'}
          label={t('vatId') + '*'}
        />
      </Grid>
      {slots?.actionArea ? (
        <Grid xs={12} md={6}>
          {slots.actionArea}
        </Grid>
      ) : null}
      <Grid xs={12} md={slots?.actionArea ? 12 : 6}>
        <FormInput {...inputProps} readonly={readonly} control={control} name={'customer.taxId'} label={t('taxId')} />
      </Grid>
      <Grid xs={12}>
        <FormInput
          {...inputProps}
          readonly={readonly}
          control={control}
          name={'customer.name'}
          label={t('businessName') + '*'}
        />
      </Grid>
      <Grid xs={12}>
        <FormInput
          {...inputProps}
          readonly={readonly}
          control={control}
          multiline={true}
          minRows={3}
          name={'customer.address'}
          label={t('streetAddress')}
        />
      </Grid>
      {slots?.end ? (
        <Grid xs={12} paddingTop={0}>
          {slots.end}
        </Grid>
      ) : null}
    </Grid>
  );
};
